import * as actions from './Actions'
import * as mutations from './Mutations'
import * as getters from './Getters'

//Statelerimiz
const state = () => ({
    loading: false,
    stockStatus: {},
    stocks: [],
    stock: {},
    stockPageInfo: {},
    movements: [],
    movementTypes: [],
    faultSupports: [],
    faultSupport: {},
    faultStatuses: [],
    faultSupportImages: [],
    pieces: [],
    faultSupportPieces: [],
    movementPageInfo: {},
    faultSupportPageInfo: {},
    faultSupportResults: [],
    faultTracking: {},
    stockMovement: {},
    untrackInfo: []
})

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Stock/index.js